import { Injectable } from '@angular/core';
import { CartModificationPayload } from '@cart/const';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CartActions } from '../store/actions';
import { StateWithCustomCart } from '../store/cart-state';
import { CompareCartSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class CompareCartService {
  constructor(protected store: Store<StateWithCustomCart>) {}

  validateCart(): void {
    this.store.dispatch(new CartActions.ValidateCart());
  }

  confirmNewCart(): void {
    this.store
      .pipe(select(CompareCartSelectors.getNewBaseSiteId))
      .subscribe((newBaseSiteId: string) => {
        this.store.dispatch(new CartActions.ConfirmDiff(newBaseSiteId));
      })
      .unsubscribe();
  }

  getDiff(): Observable<CartModificationPayload> {
    return this.store.pipe(select(CompareCartSelectors.getCompareCartValue));
  }

  compareCart(newBaseSiteId: string): void {
    this.store.dispatch(new CartActions.LoadDiff(newBaseSiteId));
  }
}
